import React from 'react'
import { ExternalPaths } from '@shared/menu-items/paths'
import WhatsApp from '@shared/svg/whats-app.svg'
import cx from 'classnames'

import styles from './style.module.scss'

export const ContactBlockLoans = () => (
	<div className={styles.contacts}>
		<div className={styles.contactsLeft}>
			<h3 className={cx(styles.h3, styles.lightText)}>
				Задайте вопросы менеджеру отдела развития партнёрской сети
			</h3>
			<a
				target='_blank'
				rel='noopener noreferrer nofollow'
				href={ExternalPaths.companyPresentation}
				className={styles.link}
			>
				Скачать презентацию о продукте
			</a>
		</div>
		<div className={styles.contactsRight}>
			<WhatsApp className={styles.whatsAppIcon} />
			<a
				href='https://api.whatsapp.com/send/?phone=79030788114&text=Хочу+оставить+заявку+на+кредит+в+Credit.Club.&type=phone_number&app_absent=0'
				target='_blank'
				rel='noopener noreferrer nofollow'
			>
				<p className={styles.whatsAppNumber}>
					WhatsApp
					<br />
					+7 (965) 525-57-70
				</p>
				<p className={styles.whatsAppName}>Артём Тарасов</p>
			</a>
		</div>
	</div>
)
